/* ContactFieldRenderer.js */

"use strict";

const _ = require("lodash");

class ContactFieldRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("contactfield-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("ContactField", (this._onContactField = this._onContactField.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeAllListeners("ContactField");
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setContactField(this._model.getValue());
            resolve();
        });
        return prom;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    _onContactField(newVal) {
        this._setContactField(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _setContactField(newVal) {
        if (_.isArray(newVal)) {
            this._rootElem.innerHTML = newVal.join(", ");
        } else {
            this._rootElem.innerHTML = "";
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = ContactFieldRenderer;
